<div class="scrollable p-2" [class.show]="!Editing">
	<app-person-detail-form
        style="padding: 0"
        #Form
		[Editing]="Editing"
		[Person]="Person"
		[IsModal]="true"
		(saved)="closeDialog($event)"
	></app-person-detail-form>
</div>

<mat-dialog-actions class="gap-2 justify-between" *ngIf="Editing">
	<button app-button [Inverted]="true" Color="cancel" type="button" (click)="closeDialog()">Abbrechen</button>
	<button app-button (click)="Save()" Color="green" type="button">Speichern</button>
</mat-dialog-actions>

<mat-dialog-actions *ngIf="!Editing">
	<button app-button [Inverted]="true" Color="cancel" type="button" (click)="closeDialog()">schließen</button>
</mat-dialog-actions>
